import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { LicenceUsersService } from '~/api/services/types'
import type {
  CreateInvitationPayload,
  Invitation,
  LicenceUser,
  Role,
  UpdateInvitationPayload,
  UpdateUserRolesPayload
} from '~/types/licence-users'

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): LicenceUsersService => {
  return {
    getUserDetails: async () => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LICENCE_USERS_GET_DETAILS)
      return await client<LicenceUser[]>(url, { method, headers, body })
    },

    getRoles: async () => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LICENCE_USERS_GET_ROLES)
      return await client<Role[]>(url, { method, headers, body })
    },

    createInvitation: async (payload: CreateInvitationPayload) => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.LICENCE_USERS_CREATE_INVITATION,
        {},
        payload
      )
      return await client<Invitation>(url, { method, headers, body })
    },

    updateUserRoles: async (userId: number, payload: UpdateUserRolesPayload) => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.LICENCE_USERS_UPDATE_ROLES,
        { params: { userId } },
        payload
      )
      return await client<LicenceUser>(url, { method, headers, body })
    },

    updateInvitation: async (invitationId: number, payload: UpdateInvitationPayload) => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.LICENCE_USERS_UPDATE_INVITATION,
        { params: { invitationId } },
        payload
      )
      return await client<LicenceUser>(url, { method, headers, body })
    }
  }
}
